import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20warm%20golden%20and%20deep%20crimson%20gradients%2C%20flowing%20curved%20shapes%20like%20film%20strips%2C%20soft%20bokeh%20lights%2C%20elegant%20and%20artistic%20streaming%20platform%20hero%20background%2C%20dark%20rich%20atmosphere%20with%20glowing%20accents&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="芭乐视频 - 高清在线观看平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading leading-tight mb-4">
            高清视频<span className="text-accent-400">免费看</span>，急速加载<span className="text-accent-400">不缓冲</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-2xl">
            芭乐视频是91视频、97视频网站的优质替代平台。涵盖电影、电视剧、综艺、动漫等海量数字视频资源，
            4K超清画质，智能推荐引擎，为你带来极致观影体验。
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/movie"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观影
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm rounded-lg font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
            >
              <i className="ri-information-line text-lg"></i>
              了解更多
            </Link>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 max-w-2xl">
          {[
            { value: '10万+', label: '视频资源' },
            { value: '4K', label: '超清画质' },
            { value: '99.9%', label: '播放成功率' },
            { value: '5000万+', label: '活跃用户' },
          ].map((stat) => (
            <div key={stat.label} className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-4 text-center border border-white/10">
              <div className="text-lg md:text-2xl font-bold text-accent-400 font-heading">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}